export const accommodationTranslations = {
  // 住宿相关翻译
  "accommodation": {
    en: "Accommodation",
    zh: "住宿"
  },
  "accommodationDesc": {
    en: "Find your perfect place to stay in Penang, from luxury hotels to budget-friendly options and long-term rentals.",
    zh: "在槟城找到您完美的住宿地点，从豪华酒店到经济实惠的选择和长期租赁。"
  },
  "accommodationOptions": {
    en: "Accommodation Options",
    zh: "住宿选择"
  },
  "findYourHomeInPenang": {
    en: "Find Your Home in Penang",
    zh: "在槟城找到您的家"
  },
  "accommodationDesc1": {
    en: "Whether you're visiting for a short stay or relocating to Penang, finding the right accommodation is essential for a comfortable experience.",
    zh: "无论您是短期访问还是搬迁到槟城，找到合适的住宿对于舒适的体验至关重要。"
  },
  "accommodationDesc2": {
    en: "Penang offers a wide range of options from luxury hotels and serviced apartments to budget-friendly hostels and long-term rentals.",
    zh: "槟城提供广泛的选择，从豪华酒店和服务式公寓到经济型旅舍和长期租赁。"
  },
  "accommodationDesc3": {
    en: "Our accommodation services can help you navigate the options, arrange viewings, and secure the best rates for your stay.",
    zh: "我们的住宿服务可以帮助您了解各种选择，安排看房，并为您的住宿获取最优惠的价格。"
  },
  "hotelsAndResorts": {
    en: "Hotels & Resorts",
    zh: "酒店和度假村"
  },
  "hotelsDesc": {
    en: "From luxury beachfront resorts to boutique heritage hotels in Georgetown.",
    zh: "从豪华的海滨度假村到乔治城的精品文化遗产酒店。"
  },
  "hotels": {
    en: "Hotels",
    zh: "酒店"
  },
  "hotelsDetailDesc": {
    en: "Ranging from international 5-star chains to boutique heritage hotels, Penang's hotel options cater to all budgets and preferences.",
    zh: "从国际五星级连锁酒店到精品文化遗产酒店，槟城的酒店选择迎合各种预算和偏好。"
  },
  "servicedApartments": {
    en: "Serviced Apartments",
    zh: "服务式公寓"
  },
  "servicedApartmentsDesc": {
    en: "Fully furnished apartments with hotel-like amenities for short to medium stays.",
    zh: "为短期至中期住宿提供的全套家具公寓，带有酒店式设施。"
  },
  "rentalProperties": {
    en: "Rental Properties",
    zh: "租赁物业"
  },
  "rentalPropertiesDesc": {
    en: "Long-term rentals are widely available, from high-rise condos with facilities to traditional shophouses in heritage areas.",
    zh: "广泛提供长期租赁，从设有设施的高层公寓到文化遗产区的传统店屋。"
  },
  "condosAndApartments": {
    en: "Condos & Apartments",
    zh: "公寓和住宅"
  },
  "condosDesc": {
    en: "Residential condominiums and apartments for long-term rentals with modern amenities.",
    zh: "带有现代化设施的长期租赁住宅公寓。"
  },
  "dailyHousekeeping": {
    en: "Daily housekeeping",
    zh: "每日客房清洁"
  },
  "restaurantAndRoomService": {
    en: "Restaurant and room service",
    zh: "餐厅和客房送餐服务"
  },
  "swimmingPoolsAndFitnessCenters": {
    en: "Swimming pools and fitness centers",
    zh: "游泳池和健身中心"
  },
  "twentyFourHourReception": {
    en: "24-hour reception",
    zh: "24小时接待"
  },
  "fullyEquippedKitchen": {
    en: "Fully equipped kitchen",
    zh: "设备齐全的厨房"
  },
  "livingAndDiningAreas": {
    en: "Living and dining areas",
    zh: "客厅和用餐区"
  },
  "weeklyHousekeeping": {
    en: "Weekly housekeeping",
    zh: "每周客房清洁服务"
  },
  "securityServicesFeature": {
    en: "Security services (e.g., 24/7 security, CCTV)",
    zh: "安保服务（例如，24/7安保，闭路电视监控）"
  },
  "fullyFurnishedOptions": {
    en: "Fully furnished options available",
    zh: "提供全套家具选项"
  },
  "facilityAccess": {
    en: "Swimming pool and gym access",
    zh: "可使用游泳池和健身房"
  },
  "securityAndParking": {
    en: "Security and parking",
    zh: "安保和停车位"
  },
  "minimumLeaseTerms": {
    en: "Minimum 12-month lease terms typical",
    zh: "通常至少12个月租期"
  },
  "condosPriceRange": {
    en: "RM1,500 - RM4,000+ per month",
    zh: "每月RM1,500 - RM4,000+"
  },
  "hostels": {
    en: "Hostels & Budget Stays",
    zh: "旅舍与经济住宿"
  },
  "hostelsDesc": {
    en: "Perfect for travelers on a budget, with dormitory-style accommodations and private rooms in central locations.",
    zh: "非常适合预算有限的旅行者，在中心位置提供宿舍式住宿和私人房间。"
  },
  "location": {
    en: "Location",
    zh: "位置"
  },
  "priceRange": {
    en: "Price Range",
    zh: "价格范围"
  },
  "amenities": {
    en: "Amenities",
    zh: "设施"
  },
  "wifiIncluded": {
    en: "WiFi Included",
    zh: "包含无线网络"
  },
  "airConditioning": {
    en: "Air Conditioning",
    zh: "空调"
  },
  "swimmingPool": {
    en: "Swimming Pool",
    zh: "游泳池"
  },
  "gymAccess": {
    en: "Gym Access",
    zh: "健身房使用权"
  },
  "kitchenFacilities": {
    en: "Kitchen Facilities",
    zh: "厨房设施"
  },
  "securityService": {
    en: "24/7 Security",
    zh: "24/7 安保服务"
  },
  "popularAreas": {
    en: "Popular Areas",
    zh: "热门区域"
  },
  "georgetown": {
    en: "Georgetown",
    zh: "乔治城"
  },
  "georgetownDesc": {
    en: "The historic city center, perfect for those who want to be surrounded by culture, food, and nightlife.",
    zh: "历史悠久的市中心，非常适合那些想被文化、美食和夜生活环绕的人。"
  },
  "gurney": {
    en: "Gurney/Tanjung Tokong",
    zh: "格尼/丹绒道光"
  },
  "gurneyDesc": {
    en: "Upscale residential areas with shopping malls, beaches, and premium condominiums.",
    zh: "高档住宅区，拥有购物中心、海滩和高级公寓。"
  },
  "batuFerringhi": {
    en: "Batu Ferringhi",
    zh: "峇都丁宜"
  },
  "batuFerringhiDesc": {
    en: "Beach resort area with luxury hotels, water sports, and a relaxed holiday atmosphere.",
    zh: "海滩度假区，有豪华酒店、水上运动和轻松的度假氛围。"
  },
  "airportArea": {
    en: "Airport Area/Bayan Lepas",
    zh: "机场区域/峇央峇鲁"
  },
  "airportAreaDesc": {
    en: "Close to the Free Industrial Zone and technology park, convenient for those working in these areas.",
    zh: "靠近自由工业区和科技园，方便在这些地区工作的人士。"
  },
  "popularLocations": {
    en: "Popular Locations",
    zh: "热门地点"
  },
  "shoppingDistricts": {
    en: "Shopping Districts",
    zh: "购物区"
  },
  "shoppingDistrictsDesc": {
    en: "Stay near major shopping centers for convenience and entertainment options.",
    zh: "住在主要购物中心附近，方便购物和娱乐。"
  },
  "touristAreas": {
    en: "Tourist Areas",
    zh: "旅游区"
  },
  "touristAreasDesc": {
    en: "Georgetown's heritage zone offers cultural immersion and proximity to attractions.",
    zh: "乔治城的文化遗产区提供文化体验和便捷的景点访问。"
  },
  "airportProximity": {
    en: "Airport Proximity",
    zh: "机场附近"
  },
  "airportProximityDesc": {
    en: "Convenient accommodations near Penang International Airport for travelers.",
    zh: "为旅客提供靠近槟城国际机场的便捷住宿。"
  },
  "bookingTips": {
    en: "Booking Tips",
    zh: "预订小贴士"
  },
  "bookEarly": {
    en: "Book Early",
    zh: "提前预订"
  },
  "bookEarlyDesc": {
    en: "For high seasons (December-January, July-August), book at least 2 months in advance to secure good rates and availability.",
    zh: "对于旺季（12月至1月，7月至8月），至少提前2个月预订以确保良好的价格和可用性。"
  },
  "compareOptions": {
    en: "Compare Options",
    zh: "比较选择"
  },
  "compareOptionsDesc": {
    en: "Use multiple booking platforms to find the best rates and reviews.",
    zh: "使用多个预订平台找到最优惠的价格和评价。"
  },
  "negotiateForLongStays": {
    en: "Negotiate for Long Stays",
    zh: "长期住宿可协商"
  },
  "negotiateForLongStaysDesc": {
    en: "For stays over 6 months, residential condos and apartments offer better value compared to serviced apartments or hotels.",
    zh: "对于超过6个月的住宿，与服务式公寓或酒店相比，住宅公寓提供更高的性价比。"
  },
  "utilities": {
    en: "Utilities",
    zh: "水电费用"
  },
  "utilitiesDesc": {
    en: "Long-term rentals typically don't include utilities. Budget approximately RM200-400 per month extra for electricity, water, and internet.",
    zh: "长期租赁通常不包含水电费。额外预算约每月RM200-400用于电费、水费和网络费用。"
  },
  "negotiation": {
    en: "Negotiation",
    zh: "谈判"
  },
  "negotiationDesc": {
    en: "For long-term leases, negotiating the rental price is common practice. You can often secure 5-10% discounts for 12-month contracts.",
    zh: "对于长期租约，租金谈判是常见做法。您通常可以为12个月合同获得5-10%的折扣。"
  },
  "shortTermBooking": {
    en: "Short-Term Booking Service",
    zh: "短期预订服务"
  },
  "shortTermBookingDesc": {
    en: "We can help arrange hotel and serviced apartment stays with preferential rates through our network of partners.",
    zh: "我们可以通过我们的合作伙伴网络安排酒店和服务式公寓住宿，提供优惠价格。"
  },
  "longTermRentalFinding": {
    en: "Long-Term Rental Finding",
    zh: "长期租赁查找"
  },
  "longTermRentalFindingDesc": {
    en: "Our specialists can identify suitable properties matching your requirements and budget for long-term stays.",
    zh: "我们的专家可以为长期住宿找到适合您要求和预算的房产。"
  },
  "leaseNegotiation": {
    en: "Lease Negotiation",
    zh: "租约谈判"
  },
  "leaseNegotiationDesc": {
    en: "We assist with negotiating favorable terms, deposits, and renewal options with landlords.",
    zh: "我们协助与房东谈判有利的条款、押金和续约选项。"
  },
  "getPersonalizedRecommendations": {
    en: "Our accommodation experts can provide personalized recommendations based on your preferences, budget, and length of stay in Penang.",
    zh: "我们的住宿专家可以根据您的偏好、预算和在槟城的停留时间提供个性化建议。"
  },
  "contactAccommodationTeam": {
    en: "Contact Our Accommodation Team",
    zh: "联系我们的住宿团队"
  },
  "ourAccommodationServices": {
    en: "Our Accommodation Services",
    zh: "我们的住宿服务"
  },
  "propertySearchAssistance": {
    en: "Property Search Assistance",
    zh: "物业搜索协助"
  },
  "propertySearchAssistanceDesc": {
    en: "Personalized help finding the perfect accommodation based on your requirements.",
    zh: "根据您的要求提供个性化帮助，寻找完美的住宿。"
  },
  "viewingArrangements": {
    en: "Viewing Arrangements",
    zh: "看房安排"
  },
  "viewingArrangementsDesc": {
    en: "We can schedule and accompany you on property viewings.",
    zh: "我们可以安排看房时间并陪同您参观物业。"
  },
  "rentalNegotiation": {
    en: "Rental Negotiation",
    zh: "租金谈判"
  },
  "rentalNegotiationDesc": {
    en: "Expert advice and assistance to secure favorable terms and rates.",
    zh: "提供专业建议和协助，确保有利的条款和价格。"
  },
  "findYourPerfectStay": {
    en: "Find Your Perfect Stay",
    zh: "找到您完美的住宿"
  },
  "contactUsToday": {
    en: "Contact Us Today",
    zh: "立即联系我们"
  },
  "contactUsTodayDesc": {
    en: "Let our accommodation specialists help you find your ideal home in Penang.",
    zh: "让我们的住宿专家帮助您在槟城找到理想的家。"
  },
  "accommodationTips": {
    en: "Accommodation Tips",
    zh: "住宿小贴士"
  },
  "bestTimeToBook": {
    en: "Best Time to Book",
    zh: "最佳预订时间"
  },
  "bestTimeToBookDesc": {
    en: "For hotels and short-term stays, book 2-3 months in advance, especially during peak tourist seasons (December-January and school holidays).",
    zh: "对于酒店和短期住宿，提前2-3个月预订，尤其是在旅游旺季（12月至1月和学校假期）。"
  },
  "longTermRentals": {
    en: "Long-term Rentals",
    zh: "长期租赁"
  },
  "longTermRentalsDesc": {
    en: "Standard rental agreements are for 1-2 years with a 2-month security deposit. Negotiation is common in the rental market.",
    zh: "标准租赁协议为1-2年，押金为2个月租金。在租赁市场中，协商是常见的。"
  },
  "budget": {
    en: "Budget Considerations",
    zh: "预算考虑"
  },
  "budgetDesc": {
    en: "Monthly rent for a decent 3-bedroom apartment ranges from RM1,200-3,000 depending on location and facilities.",
    zh: "一个不错的三居室公寓的月租金范围为1,200-3,000林吉特，具体取决于位置和设施。"
  },
  "affordable": {
    en: "Affordable",
    zh: "经济实惠"
  },
  "midRange": {
    en: "Mid-range",
    zh: "中等价位"
  },
  "luxury": {
    en: "Luxury",
    zh: "豪华"
  },
  "tanjungBungahAlt": {
    en: "Tanjung Bungah Area",
    zh: "丹绒武雅地区"
  },
  "georgetownAlt": {
    en: "Georgetown Area",
    zh: "乔治市地区"
  },
  "gelugorAlt": {
    en: "Gelugor Area",
    zh: "牛汝莪地区"
  }
};
